import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import 'swiper/css'
import 'swiper/css/effect-cards'
import { all_routes } from '../../../router/all_routes'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'

const BannerSection = () => {
  // const [selectedItems, setSelectedItems] = useState(Array(4).fill(false));
  // const handleItemClick = (index: number) => {
  //   setSelectedItems((prevSelectedItems) => {
  //     const updatedSelectedItems = [...prevSelectedItems];
  //     updatedSelectedItems[index] = !updatedSelectedItems[index];
  //     return updatedSelectedItems;
  //   });
  // };
  // const handleSubmit = (event: React.FormEvent) => {
  //   event.preventDefault();
  //   const Path = route.courseList;
  //   navigate(Path);
  // };

  const userReviews = [
    {
      reviewer: 'apt. Afia Khaira, S.Farm - Freshgraduate',
      review: 'Materi yang Disampaikan Sangat menarik, Pemateri dapat Menjelaskan dengan Baik dan Tim Jadipraktisi Membawakan Acara dengan Sangat Baik.'
    },
    {
      reviewer: 'apt. Siska Tri Wahyuni, S.Farm - PT. Rohto Laboratories Indonesia',
      review: 'Susunan Acara dan Pelaksanaannya Sudah Baik. Pemateri Banyak Sharing Pengalaman. Nice.'
    },
    {
      reviewer: 'apt. Elvira Herprabayu, S.Farm - RS Mitra Keluarga',
      review: 'Pemateri dan Panitianya Keren Karena Sudah Mengadakan Forum ini, Terimakasih.'
    },
    {
      reviewer: 'apt. Mira Ismiliawaty, S.Si - RSUD dr. Rubini Mempawah',
      review: 'Pelatihan ini Sangat Menarik, Narsumnya Kompeten, Materinya Menarik, Penyampaiannya Komunikatif, Panitia Sangat Membantu. Good job.'
    },
    {
      reviewer: 'apt. Dra. Hanifdar, MARS - RSUD Sekayu',
      review: 'Sudah 3 Ikut Webinar Jadipraktisi Alhamdulillah Materi sesuai dengan Kebutuhan di Lapangan.'
    },
    {
      reviewer: 'Erna Mariana - GE Healthcare Indonesia',
      review: 'Sangat Diluar Ekspetasi (positif) dengan Biaya yang Sangat Murah dapat Ilmu yang Sangat Mahal.'
    },
    {
      reviewer: 'apt. Muhammad Nur Rahman, S.Farm - PT. Frisian Flag Indonesia',
      review: 'Wah Semua Materi yang Disampaikan Sangat Jelas dan Lengkap. Apalagi dengan Pemateri yang Handal Bagaimana Cara Kita kalau di Lapangan yang di Terapkan Materi CDOB.'
    },
    {
      reviewer: 'apt. Yanyan Solehuddin - PT. Kimia Farma',
      review: 'Materinya Bagus, Narasumber Berpengalaman. Meski Saya Kerja di Industri tapi Bisa Memahami juga yang Disampaikan.'
    },
    {
      reviewer: 'apt. Aby Gheea Benjamin, S.Farm - PT. Henson Farma',
      review: 'Materi yang Disampaikan Menarik dan Interaktif, Menambah Wawasan dan Insight Baru tentang QC Management, Ditunggu Kelas Berikutnya.'
    },
    {
      reviewer: 'apt. Yeyen Simbolon, S.Farm - RS Brawijaya Saharjo',
      review: 'Dengan Adanya Kelas Jadipraktisi merupakan Salah Satu Wadah Pembelajaran untuk Meningkatkan Pengetahuan sebagai Apoteker. Ini adalah Kelas yang Saya ikuti Pertama kali, Karena Saya tertarik dengan Materi Pemantauan Terapi Obat.'
    },
    {
      reviewer: 'apt. Dendi Putro Anggomantio, S.Farm - PT. Konimex',
      review: 'Materi Sangat Bermanfaat, QnA Memberikan Informasi-informasi Baru.'
    },
    {
      reviewer: 'Siti Maulidina Nur Fadillah, S.Farm - PT Continental Cosmetic',
      review: 'Terima kasih untuk Jadipraktisi, Materi yang Diberikan Memberikan Pencerahan untuk Permasalahan Real di Industri Saat ini. Sharing yang diberikan oleh Narasumber yang Sudah Memiliki Banyak Pengalaman di Industri Kosmetik.'
    },
    {
      reviewer: 'PT Lotus Internasional Group',
      review: 'Pembelajarannya Bagus dan Sesuai Kebutuhan, Tidak Hanya Memaparkan Teori CDOB saja tetapi membahas Langkah-Langkah Sertifikasi CDOB dan juga Teknis di Lapangannya. Mentor Menguasai materi CDOB dan Teknisnya. Review SOP dan CAPA dari Mentor juga Sangat Membantu.'
    },
    {
      reviewer: 'PT Ifars Pharmaceutical Laboratories',
      review: 'Penyelenggaraan Pelatihan Sudah Sangat Baik. Kedepannya, Semoga Pelatihan Semakin Seru, Lebih Interaktif dan ada Lebih Banyak Hadiah. Jangan lupa Informasikan jika ada Pelatihan Baru di Jadipraktisi.'
    },
    {
      reviewer: 'PT Meiji Indonesia',
      review: 'Tapi Materi Hari ini Benar-benar Memberikan Banyak insight bagi Kami yang akan Mengaplikasikan CSV dengan Benar. Semoga Berjumpa di Topik yang lainnya.'
    }
  ];

  const ReviewPrevArrow =  ({ onClick }: { onClick?: () => void }) => (
    <div onClick={onClick} className="scroll-button scroll-review scroll-review-left cursor-pointer">
      <i className="isax isax-arrow-left-2 text-white" style={{ fontSize: '24px' }}></i>
    </div>
  );

  const ReviewNextArrow =  ({ onClick }: { onClick?: () => void }) => (
    <div onClick={onClick} className="scroll-button scroll-review scroll-review-right cursor-pointer">
      <i className="isax isax-arrow-right-3 text-white" style={{ fontSize: '24px' }}></i>
    </div>
  );

  const reviewSliderSettings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    // prevArrow: <ReviewPrevArrow />,
    // nextArrow: <ReviewNextArrow />,

    responsive: [
      {
        breakpoint: 992, // MD - below LG
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // SM
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* banner */}
      <section className="banner-section">
        <ImageWithBasePath
          className="img-fluid d-none d-lg-flex banner-bg1"
          src="/assets/img/bg/bg-15.png"
          alt="img"
        />
        <ImageWithBasePath
          className="img-fluid d-none d-lg-flex banner-bg2"
          src="/assets/img/bg/bg-16.png"
          alt="img"
        />
        <ImageWithBasePath
          className="img-fluid d-none d-lg-flex banner-bg3"
          src="/assets/img/bg/bg-17.png"
          alt="img"
        />
        <ImageWithBasePath
          className="img-fluid d-none d-lg-flex banner-bg4"
          src="/assets/img/bg/bg-18.png"
          alt="img"
        />
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
              <div className="banner-content pe-xxl-5">
                <h1 className="mb-4 text-white">
                  <span>#UpgradeSkillPraktisi</span> <br />dan Rintis Karir Kesehatan <br />
                  bersama Jadipraktisi!
                </h1>
                <p className="fs-lg text-start text-white pb-2 pb-md-3 mb-4 fw-medium">
                  Berhenti Batasi Diri, Mulai Kembangkan Skill dan Rintis Karir <br />di Bidang Kesehatan bersama Mentor Expert terpercaya Jadipraktisi!
                </p>

                <div className="d-flex mb-4">
                  <button
                    className="btn btn-white btn-lg fw-bold border-0"
                    style={{
                      borderRadius: '20px',
                      fontSize: '20px',
                      transition: 'all 0.3s ease',
                      padding: '10px 20px'
                    }}
                    onClick={() => {
                      const element = document.getElementById(
                        'whySection',
                      )
                      if (element) {
                        const y = element.getBoundingClientRect().top + window.scrollY - 40;

                        window.scrollTo({
                          top: y,
                          behavior: 'smooth'
                        })
                      }
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)'
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)'
                    }}
                  >
                    Pelajari Sekarang
                  </button>

                  <Link
                    className="btn btn-yellow btn-lg fw-bold border-0 ms-3"
                    style={{
                      borderRadius: '20px',
                      fontSize: '20px',
                      transition: 'all 0.3s ease',
                      padding: '10px 20px',
                      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
                    }}
                    to={all_routes.register}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)'
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)'
                    }}
                  >
                    Daftar Gratis
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0">
              <div className="community-img d-flex justify-content-center">
                <ImageWithBasePath
                  src="assets/img/hero-image.png"
                  alt="img"
                  className="img-fluid"
                  height={580}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-4 position-relative">
          {/* Arrow */}

          <div className="mt-4 review-slider">
            <Slider {...reviewSliderSettings}>
              {userReviews.map((review, index) => (
                <div key={index} className="px-2 h-100">
                  <div
                    className="card border-0 shadow-none card-review h-100"
                    style={{ height: "100%" }}
                  >
                    <div className="card-body body-review d-flex flex-column justify-content-between h-100 fixed-height-card">

                      <p className="fw-semibold mb-1 flex-grow-1" style={{ fontSize: "10px" }}>
                        {review.review}
                      </p>

                      <div>
                        <i className="fa-solid fa-star text-warning" />
                        <i className="fa-solid fa-star text-warning" />
                        <i className="fa-solid fa-star text-warning" />
                        <i className="fa-solid fa-star text-warning" />
                        <i className="fa-solid fa-star text-warning" />
                      </div>

                      <p className="fw-bold mb-0 mt-1" style={{ fontSize: "10px" }}>
                        {review.reviewer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      {/* banner */}
    </>
  )
}

export default BannerSection
